import uniqid from 'uniqid'
import { Link } from 'react-router-dom'
import GitHubIcon from '@material-ui/icons/GitHub'
import LaunchIcon from '@material-ui/icons/Launch'
import './ProjectContainer.css'

const ProjectContainer = ({ project, id }) => (
  <Link to={`/projects/${id}`} className='project-link'>
    <div className='project'>

    {project.image && (
      <img
        src={
          project.image.startsWith('http')
            ? project.image
            : `${process.env.PUBLIC_URL}/images/${project.image}`
        }
        alt={`${project.name} screenshot`}
        className='projects__image' /* style={{ width: '100%', height: '200px', objectFit: 'contain', objectPosition: 'center' }} */
      />
    )}

    <h3>{project.name}</h3>

    <p className='project__description'>{project.description}</p>
    {project.stack && (
      <ul className='project__stack'>
        {project.stack.map((item) => (
          <li key={uniqid()} className='project__stack-item'>
            {item}
          </li>
        ))}
      </ul>
    )}

    {project.sourceCode && (
      <a
        href={project.sourceCode}
        aria-label='source code'
        className='link link--icon'
        onClick={(event) => event.stopPropagation()}
      >
        <GitHubIcon />
      </a>
    )}

    {project.livePreview && (
      <a
        href={project.livePreview}
        aria-label='live preview'
        className='link link--icon'
        onClick={(event) => event.stopPropagation()}
      >
        <LaunchIcon />
      </a>
    )}
    </div>
  </Link>
)

export default ProjectContainer
